import i18n from "src/i18n";
import { htmlLocales } from "#constants";

type useNumberFormat = (number: number, minimumFractionDigits?: number) => string;

export const useNumberFormat: useNumberFormat = (number, minimumFractionDigits = 0) => {
  const nf = new Intl.NumberFormat(htmlLocales[i18n.language] || "en", { minimumFractionDigits });
  return nf.format(number);
};
